//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import statusBus from "../libs/statusBus";

export default {
  components: {
  },
  data() {
    return {
      statusBus: statusBus,
      screenWidth: document.body.clientWidth,
      showQRcode: false,
      navData: {},
      versionInfo: '',
      footerShow: false
    };
  },
  methods: {
    enter: function () {
      this.showQRcode = true
    },
    leave: function () {
      this.showQRcode = false
    },
    setCommonData() {
      this.navData = staticData.nav;
      this.versionInfo = staticData.website.site_info.site_copyright || "";
    },
  },
  created() {
    this.statusBus.isPC = this.screenWidth > 1024;
    window.addEventListener("resize", () => {
      this.statusBus.isPC = document.documentElement.clientWidth > 1024;
    });
  },
  mounted() {
    this.setCommonData();
  },
  watch: {
    $route: {
      handler(to, from) {
        if (this.$route.path == '/' || this.$route.path == '/about/us') {
          this.footerShow = true
        } else {
          this.footerShow = false
        }
      },
      deep: true,
      immediate: true
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/com-footer.vue